import React from 'react'

import { Image } from '../../components'
import richTextRenderer from '../../components/RichTextParser/RichTextParser'
import Video from '../../components/VideoComponent/VideoComponent'
import useMediaQuery from '../../hooks/useMediaQuery'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { ALLOWED_WORDS, replaceWordInString } from '../../utils/helpers'
import {
  contactImage,
  contentContainer,
  contentContainerStyling,
  contentRowContainerStyling,
  contentStyling,
  contentVideoWidth,
  darkBgStyling,
  headingContainerStyling,
  mobileImage,
  sectionBackGround,
  sectionContainer,
  videoContainer,
} from './TreatmentIntroSection.module.css'

const TreatmentIntroSection = ({ component, lang, pageType, slice }) => {
  const {
    treatmentintrobackground,
    treatmentintrocontainerwidth,
    treatmentintrocontent,
    treatmentintroheading,
    treatmentintrokicker,
    ytvideoid,
  } = slice
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const lightHeadingComponents =
    component === 'aboutintro' ||
    component === 'contactmixedcontent' ||
    pageType === 'about' ||
    pageType === 'contact'

  return (
    <SectionLayout
      backGround={treatmentintrobackground}
      backgroundClassName={sectionBackGround}
      containerwidth={treatmentintrocontainerwidth}
      extraClassName={sectionContainer}
      extraContentClassName={contentContainer}
      extraHeaderClassName={contentContainerStyling}
      extraHeadingClassName={`${
        lightHeadingComponents && isDesktop ? darkBgStyling : ''
      } ${headingContainerStyling}`}
      heading={replaceWordInString(
        treatmentintroheading,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      kicker={replaceWordInString(
        treatmentintrokicker,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      withHeader
    >
      <div
        className={
          ytvideoid ? contentRowContainerStyling : contentContainerStyling
        }
      >
        {!isDesktop && treatmentintrobackground && (
          <Image
            alt={treatmentintrobackground.alt || 'Kliniken Image'}
            className={`${mobileImage} ${
              component === 'contactmixedcontent' ? contactImage : ''
            }`}
            src={treatmentintrobackground.node.localFile.childImageSharp}
          />
        )}
        {treatmentintrocontent && (
          <div
            className={`${ytvideoid ? contentVideoWidth : contentStyling} ${
              lightHeadingComponents && isDesktop ? darkBgStyling : ''
            }`}
          >
            {richTextRenderer(
              replaceWordInString(
                treatmentintrocontent,
                'botox',
                ALLOWED_WORDS[lang],
              ),
            )}
          </div>
        )}
        {ytvideoid && (
          <Video
            className={videoContainer}
            videoID={ytvideoid}
            videoTitle={treatmentintroheading}
          />
        )}
      </div>
    </SectionLayout>
  )
}

export default TreatmentIntroSection
